const React = require("react");
// Using CommonJS syntax because of conditional require in the PluginCard Component

const AlceSVG = props => (
  <svg
    className="logo"
    width="100%"
    height="100%"
    viewBox="0 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: `evenodd`,
      clipRule: `evenodd`,
      strokeLinejoin: `round`,
      strokeMiterlimit: `2`,
    }}
  >
    <g transform="matrix(1,0,0,1,-60,-40)">
      <g transform="matrix(0.90566,0,0,0.941176,60,-0.470588)">
        <rect x="0" y="43" width="53" height="51" style={{ fill: `none` }} />
        <clipPath id="_clip1">
          <rect x="0" y="43" width="53" height="51" />
        </clipPath>
        <g
          id="Fill-ONLY"
          transform="matrix(1.08116,0,0,1.04036,0.552083,1.91667)"
        >
          <path
            d="M48,52C48,45.377 42.623,40 36,40L12,40C5.377,40 0,45.377 0,52L0,76C0,82.623 5.377,88 12,88L36,88C42.623,88 48,82.623 48,76L48,52Z"
            style={props ? { fill: props.backgroundcolor } : {}}
            className="logo-frame-fill"
          />
        </g>
        <g clipPath="url(#_clip1)">
          <g
            id="ALCE-fill"
            transform="matrix(1.52594,-0.393445,0.408874,1.46836,3.08403,64.9597)"
          >
            <path
              d="M16,6L6.25,6C4.456,6 3,7.456 3,9.25L3,10.798C3.059,12.827 5.21,13.781 6.25,14.048L11.512,15.286C13.302,15.663 15.994,14.575 16,12.036L16,6Z"
              className="logo-color-transparency"
              style={
                props ? { fill: props.color, fillOpacity: props.opacity } : {}
              }
            />
          </g>
          <g
            id="ALCE-shape"
            transform="matrix(1.10417,2.94903e-17,0,1.0625,-66.25,0.5)"
          >
            <path
              d="M91.821,60.862L90.1,54.441C89.974,53.969 90.254,53.484 90.726,53.357C91.197,53.231 91.682,53.511 91.809,53.983L93.529,60.404L93.685,60.362C96.114,59.711 97.557,57.211 96.906,54.783L94.849,47.104C94.722,46.632 95.003,46.147 95.474,46.02C95.946,45.894 96.431,46.174 96.557,46.646C96.557,46.646 98.615,54.325 98.615,54.325C99.518,57.697 97.515,61.167 94.143,62.071L88.21,63.66L90.217,71.149C91.309,75.268 87.476,78.247 84.41,78.413L76.642,78.652C75.786,78.661 74.433,78.519 73.177,77.988C71.821,77.416 70.59,76.405 70.09,74.733L69.51,72.569C68.719,69.619 70.473,66.582 73.423,65.791L82.322,63.407L81.577,60.623C81.45,60.152 81.731,59.666 82.202,59.54C82.674,59.414 83.159,59.694 83.285,60.166L84.031,62.949L91.821,60.862ZM86.501,64.118L73.881,67.5C71.874,68.038 70.681,70.104 71.219,72.111L71.787,74.233C72.121,75.339 72.967,75.979 73.865,76.358C74.864,76.78 75.942,76.89 76.605,76.883C76.605,76.883 84.336,76.646 84.315,76.646C86.477,76.53 89.277,74.508 88.507,71.605L86.501,64.118Z"
              className="logo-color"
              style={props ? { fill: props.color } : {}}
            />
          </g>
          <g id="Frame" transform="matrix(1.10417,0,0,1.0625,0,0.5)">
            <path
              d="M48,52C48,45.377 42.623,40 36,40L12,40C5.377,40 0,45.377 0,52L0,76C0,82.623 5.377,88 12,88L36,88C42.623,88 48,82.623 48,76L48,52ZM46,52L46,76C46,81.519 41.519,86 36,86C36,86 12,86 12,86C6.481,86 2,81.519 2,76C2,76 2,52 2,52C2,46.481 6.481,42 12,42L36,42C41.519,42 46,46.481 46,52Z"
              className="logo-frame"
              style={props ? { fill: props.color } : {}}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
exports.Logo = AlceSVG;

// export default AlceSVG;
